// app/src/lib/start/app-switcher.js

'use strict';

function setCookie(name, value, { maxAge = 31536000, path = '/', sameSite = 'Lax', secure = (location.protocol === 'https:'), domain } = {}) {
	const parts = [
		`${name}=${encodeURIComponent(value)}`,
		`Path=${path}`,
		`Max-Age=${maxAge}`,
		`SameSite=${sameSite}`
	];
	if (secure) parts.push('Secure');
	if (domain) parts.push(`Domain=${domain}`);
	document.cookie = parts.join('; ');
}
function getCookie(name) {
	return document.cookie.split('; ').find(c => c.startsWith(name + '='))?.split('=')[1] || null;
}
function readCookie(name) {
	const raw = getCookie(name);
	return raw ? decodeURIComponent(raw) : null;
}

function switchToV3(config) {
	setCookie('preferredApp', 'v3', { maxAge: 31536000, sameSite: 'Lax', secure: true, domain: config && config.cookieDomain });
	location.href = 'https://app3.mindmup.com/?switch=3';
}

function ensureInter() {
	if (document.getElementById('mm-inter-font')) return;
	const link = document.createElement('link');
	link.id = 'mm-inter-font';
	link.rel = 'stylesheet';
	link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
	document.head.appendChild(link);
}

function renderTopBanner(config) {
	if (document.getElementById('mm-app-switcher-banner')) return;
	if (window.top !== window.self) return;

	ensureInter();

	const banner = document.createElement('div');
	banner.id = 'mm-app-switcher-banner';
	banner.setAttribute('aria-label', 'MindMup 3.0 announcement');

	banner.innerHTML = '' +
		'<div class="mm-as-banner-inner">' +
		'<div class="mm-as-banner-text">' +
		'<span class="mm-as-banner-icon" aria-hidden="true">' +
		'<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
		'<path d="M8.29888 7.61321L9.03721 5.03071C9.31388 4.06405 10.6839 4.06405 10.9605 5.03071L11.698 7.61321C11.7447 7.77658 11.8323 7.92535 11.9524 8.04549C12.0726 8.16564 12.2213 8.25319 12.3847 8.29988L14.9672 9.03738C15.9339 9.31405 15.9339 10.684 14.9672 10.9607L12.3847 11.6982C12.2213 11.7449 12.0726 11.8325 11.9524 11.9526C11.8323 12.0727 11.7447 12.2215 11.698 12.3849L10.9605 14.9674C10.6839 15.934 9.31388 15.934 9.03721 14.9674L8.29971 12.3849C8.25302 12.2215 8.16547 12.0727 8.04533 11.9526C7.92518 11.8325 7.77641 11.7449 7.61305 11.6982L5.03055 10.9607C4.06388 10.684 4.06388 9.31405 5.03055 9.03738L7.61305 8.29988C7.77641 8.25319 7.92518 8.16564 8.04533 8.04549C8.16547 7.92535 8.25302 7.77658 8.29971 7.61321M15.0855 13.7549C15.3264 13.0524 16.3389 13.0515 16.5789 13.7549L16.6005 13.8274L16.8472 14.8174L17.8372 15.0649C18.6372 15.2649 18.6372 16.3999 17.8372 16.5999L16.8472 16.8474L16.6005 17.8374C16.4005 18.6365 15.2647 18.6365 15.0647 17.8374L14.8172 16.8474L13.8272 16.5999C13.0272 16.3999 13.0272 15.264 13.8272 15.0649L14.8172 14.8174L15.0647 13.8274L15.0855 13.7549ZM15.8322 15.6632C15.7843 15.7274 15.7273 15.7844 15.663 15.8324C15.7273 15.8803 15.7843 15.9373 15.8322 16.0015C15.8802 15.9373 15.9371 15.8803 16.0014 15.8324C15.9371 15.7842 15.8801 15.7269 15.8322 15.6624M3.41888 2.08738C3.66721 1.36155 4.73971 1.38571 4.93388 2.15988L5.18055 3.14988L6.17055 3.39738C6.97055 3.59738 6.97055 4.73238 6.17055 4.93238L5.18055 5.17988L4.93388 6.16988C4.73388 6.96905 3.59805 6.96905 3.39805 6.16988L3.15055 5.17988L2.16055 4.93238C1.36055 4.73238 1.36055 3.59655 2.16055 3.39738L3.15055 3.14988L3.39805 2.15988L3.41888 2.08738ZM4.16555 3.99655C4.11753 4.06048 4.06055 4.11718 3.99638 4.16488C4.06067 4.21309 4.11765 4.27035 4.16555 4.33488C4.21344 4.27035 4.27042 4.21309 4.33471 4.16488C4.27048 4.11692 4.21351 4.06078 4.16555 3.99655Z" fill="#FFF"/>' +
		'</svg>' +
		'</svg>' +
		'</span>' +
		'<button class="mm-as-banner-try" id="mm-as-banner-try" aria-label="Try Mindmup 3.0"><span class="mm-as-banner-copy">Mindmup 3 replaces the current version on April 13. <strong>Preview Mindmup 3</strong></span>' +
		'</button>' +
		'</div>' +
	'</div>';

	document.body.insertBefore(banner, document.body.firstChild);

	document.getElementById('mm-as-banner-try').addEventListener('click', function () {
		switchToV3(config);
	});
}

function renderModal(config) {
	if (document.getElementById('mm-app-switcher-overlay')) return;

	ensureInter();

	const overlay = document.createElement('div');
	overlay.id = 'mm-app-switcher-overlay';
	overlay.setAttribute('role', 'dialog');
	overlay.setAttribute('aria-modal', 'true');

	overlay.innerHTML = `
		<div class="mm-app-switcher-dialog">
			<button class="mm-as-close" aria-label="Close">
				<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
					<path d="M1.62682 1.00222C1.50271 1.00226 1.38143 1.0393 1.27848 1.10862C1.17554 1.17794 1.09561 1.27639 1.04891 1.39138C1.00221 1.50636 0.990858 1.63266 1.01631 1.75413C1.04177 1.8756 1.10287 1.98672 1.19181 2.07328L5.11781 5.99928L1.19181 9.92527C1.13194 9.98276 1.08414 10.0516 1.0512 10.1278C1.01827 10.204 1.00088 10.286 1.00003 10.369C0.999188 10.452 1.01491 10.5343 1.04629 10.6112C1.07766 10.688 1.12405 10.7578 1.18275 10.8165C1.24144 10.8752 1.31125 10.9216 1.3881 10.953C1.46495 10.9844 1.54728 11.0001 1.63028 10.9992C1.71328 10.9984 1.79528 10.981 1.87147 10.9481C1.94766 10.9151 2.01652 10.8673 2.074 10.8075L6 6.88147L9.92599 10.8075C9.98348 10.8673 10.0523 10.9151 10.1285 10.9481C10.2047 10.981 10.2867 10.9984 10.3697 10.9992C10.4527 11.0001 10.5351 10.9844 10.6119 10.953C10.6887 10.9216 10.7586 10.8752 10.8173 10.8165C10.8759 10.7578 10.9223 10.688 10.9537 10.6112C10.9851 10.5343 11.0008 10.452 11 10.369C10.9991 10.286 10.9817 10.204 10.9488 10.1278C10.9159 10.0516 10.8681 9.98276 10.8082 9.92527L6.88219 5.99928L10.8082 2.07328C10.8983 1.98565 10.9599 1.87283 10.9848 1.7496C11.0098 1.62638 10.9969 1.49849 10.9479 1.38271C10.8989 1.26693 10.8161 1.16865 10.7102 1.10076C10.6044 1.03286 10.4806 0.998518 10.3549 1.00222C10.1928 1.00705 10.039 1.07479 9.92599 1.19109L6 5.11709L2.074 1.19109C2.01587 1.13133 1.94634 1.08382 1.86953 1.05138C1.79272 1.01895 1.71019 1.00223 1.62682 1.00222Z" fill="#2C2E33"/>
				</svg>
			</button>
			<div class="mm-as-split">
				<section class="mm-as-left" aria-labelledby="mm-app-switcher-title">
					<div class="mm-as-logo" aria-hidden="true">
						<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="14.0006" cy="14.0006" r="4.41987" stroke="#2C2E33" stroke-width="1.45837"/>
							<circle cx="4.48886" cy="10.051" r="2.70352" transform="rotate(22.5469 4.48886 10.051)" stroke="#2C2E33" stroke-width="1.45837"/>
							<circle cx="17.948" cy="4.48886" r="2.70352" transform="rotate(112.547 17.948 4.48886)" stroke="#2C2E33" stroke-width="1.45837"/>
							<circle cx="17.9318" cy="23.5184" r="2.70352" transform="rotate(-112.453 17.9318 23.5184)" stroke="#2C2E33" stroke-width="1.45837"/>
							<circle cx="4.48353" cy="17.9337" r="2.70352" transform="rotate(-22.4531 4.48353 17.9337)" stroke="#2C2E33" stroke-width="1.45837"/>
							<circle cx="23.5103" cy="17.9495" r="2.70352" transform="rotate(22.5469 23.5103 17.9495)" stroke="#2C2E33" stroke-width="1.45837"/>
							<circle cx="10.0525" cy="23.5123" r="2.70352" transform="rotate(112.547 10.0525 23.5123)" stroke="#2C2E33" stroke-width="1.45837"/>
							<circle cx="10.0685" cy="4.48327" r="2.70352" transform="rotate(-112.453 10.0685 4.48327)" stroke="#2C2E33" stroke-width="1.45837"/>
							<circle cx="23.5167" cy="10.0665" r="2.70352" transform="rotate(-22.4531 23.5167 10.0665)" stroke="#2C2E33" stroke-width="1.45837"/>
							</svg>

					</div>
					<div class="mm-as-content">
					<h2 id="mm-app-switcher-title" class="mm-as-title">Mindmup 3 is replacing Mindmup 2</h2>
					<p class="mm-as-desc">
						Starting <span style="color:#22a550;font-weight:600">April 13</span>, all accounts will begin migrating to Mindmup 3. Your maps and data will move automatically as Mindmup 3 becomes the new standard.
					</p>
					<div class="mm-as-actions">
						<button class="mm-btn mm-btn-primary" id="mm-try-v3"><span>Preview Mindmup 3</span></button>
						<a class="mm-btn mm-btn-secondary" href="https://www.mindmup.com/help/news/mindmup-3-migration/" target="_blank" rel="noopener"><span>Learn more</span></a>
					</div>
					</div>
					<button class="mm-as-later" id="mm-maybe-later" aria-label="Got it, thanks">Got it, thanks</button>
				</section>
				<aside class="mm-as-right" aria-hidden="true"><img class="mm-as-preview" src="/assets/introducing-mindmup.png" alt="" /></aside>
			</div>
		</div>
	`;

	function close() {
		document.body.style.overflow = '';
		overlay.remove();
	}

	overlay.addEventListener('click', (e) => {
		if (e.target === overlay) close();
	});
	overlay.querySelector('.mm-as-close').addEventListener('click', close);

	overlay.querySelector('#mm-try-v3').addEventListener('click', () => switchToV3(config));

	overlay.querySelector('#mm-maybe-later').addEventListener('click', () => {
		// remember dismissal for 10 days;
		setCookie('m3_modal_dismissed', '1', { maxAge: 60 * 60 * 24 * 10, sameSite: 'Lax', secure: true, domain: config && config.cookieDomain });
		close();
	});

	document.body.appendChild(overlay);
	document.body.style.overflow = 'hidden';
}

function shouldShowModal() {
	// do not show if already opted into v3 or the modal was dismissed
	if (readCookie('preferredApp') === 'v3') return false;
	if (readCookie('m3_modal_dismissed') === '1') return false;

	if (window.top !== window.self) return false;

	return true;
}

function initAppSwitcher(config) {
	try {
		if (config && config.showAppSwitcher === false) return;
		renderTopBanner(config);
		if (shouldShowModal()) renderModal(config);
	} catch (err) {
		console.warn('App switcher error', err);
	}
}

module.exports = {
	initAppSwitcher,
	switchToV3
};
